import { jsx as _jsx } from "preact/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useContext, useEffect, useState } from 'preact/compat';
import Notice from '@widgets/shared/components/Notice';
import AttendeesSelector from '@genericBookings/components/AttendeesSelector';
import { useMemo } from 'react';
import { visitorCount, visitorsFromSchema } from '@genericBookings/visitorUtils';
import { defaultVisitors } from '@genericBookings/types/Visitors';
import { useAppDispatch } from '@genericBookings/store/hooks';
import { OptionsCTX } from '@widgets/DIYDayTickets/context/Options';
import { useStepCompletion } from '@widgets/DayTickets/context/Steps';
function AttendeesModal(props) {
    const { getValues, watch, } = useFormContext();
    const { dayTicketId } = useContext(OptionsCTX);
    const dispatch = useAppDispatch();
    const { loggedIn, } = useContext(OptionsCTX);
    const { onChange, onClose, activity, activityIdx, } = props;
    const stopProp = (ev) => {
        ev.stopImmediatePropagation();
    };
    const maybeVisitors = watch(`Sessions.${activityIdx}`);
    console.log(maybeVisitors);
    const activityVisitors = visitorsFromSchema(watch(`Sessions.${activityIdx}`));
    const totalVisitors = useMemo(() => visitorCount(activityVisitors ?? defaultVisitors), [activityVisitors]);
    const { activitiesStep } = useStepCompletion();
    const buttonText = useMemo(() => {
        if (activity.selected) {
            if (totalVisitors === 0) {
                return 'Remove';
            }
            return 'Update';
        }
        return 'Confirm';
    }, [activity, totalVisitors]);
    const [canProceed, setCanProceed] = useState(activity?.selected ?? false);
    useEffect(() => {
        setCanProceed(activity.selected || totalVisitors > 0);
    }, [activity, totalVisitors]);
    if (!activity.activity.priceBands || !activity.activity.productBands)
        return null;
    return (_jsx(Notice, { onClose: onClose, children: _jsx(AttendeesSelector, { prefixName: `Sessions.${activityIdx}.`, name: `Visitors.${activityIdx}`, accent: "var(--primary-darker)", activity: activity, onNextSection: () => {
                // dispatch(setTheVisitorsForActivity(activityVisitors, activityDetailed));
                onChange(activity);
            }, canProceed: canProceed, canProceedText: buttonText, showButtonWhenDisabled: true, loggedIn: loggedIn, options: OptionsCTX, productId: dayTicketId }) }));
}
export default AttendeesModal;
